import { get } from '@_shared/config';

import { popupModel } from '../model';

export async function getPopupList() {
	return get<popupModel.TPopup[]>('/infra/pop-up');
}
